module.exports = __webpack_public_path__ + "img/under_construction.d7b2e3a9.png";